<template>
  <v-dialog v-model="dialog" max-width="600">
    <template v-slot:activator="{ on, lgModal }">
      <v-btn
        x-large
        elevation="3"
        class="ma-2"
        color="primary"
        v-bind="lgModal"
        v-on="on"
        >Click Me</v-btn
      >
    </template>
    <v-card elevation="3" class="modal-card">
      <v-card-title>
        <h3>Project Overview</h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <hr />
      </v-card-title>
      <div class="modal-img">
        <iframe
          src="https://player.vimeo.com/video/200732753"
          frameborder="0"
          webkitallowfullscreen
          mozallowfullscreen
          allowfullscreen
          class="iframe-video"
        ></iframe>
      </div>
      <div class="project-info">
        <h1>Lemon Grass Kitchen <br />Commercial</h1>
        <p>Commercial Video for Lemon Grass Kitchen</p>
        <ul class="details">
          <li><label>Client:</label>Lemon Grass Kitchen</li>
          <li><label>Category:</label>Video Production</li>
          <li><label>Agency:</label>Victors and Spoils</li>
          <li><label>Director:</label>Aaron Hartshorn</li>
          <li><label>Role:</label>Key Grip</li>
          <li>
            <label>Project URL:</label
            ><a target="_blank" href="https://vimeo.com/200732753"
              ><v-icon>mdi-vimeo</v-icon> View on Vimeo</a
            >
          </li>
        </ul>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },
};
</script>

<style lang="scss">
</style>